export const UPDATE_ACADEMIC = 'UPDATE_ACADEMIC';
export const UPDATE_FINANCIAL = 'UPDATE_FINANCIAL';
export const UPDATE_FILE = 'UPDATE_FILE';